import { Environment } from '@thiememeulenhoff/types';
import { OneGateEnvironmentType } from './environment.type';

export const environment: OneGateEnvironmentType = {
  environment: Environment.Test,
  production: false,
  backendUrl: 'https://test.onegate.thiememeulenhoff.nl/api/',
  editionFallbackUrl: 'https://test.edition.thiememeulenhoff.nl/secure/next',
  toegangSso: {
    authUrl: 'https://idp-test.toegang.org/oidc/auth',
    clientId: 'NT2',
    silentRedirectUri:
      'https://test.onegate.thiememeulenhoff.nl/silent-callback',
  },
};
